var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row empty-state"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"svg-content"},[_c('img',{attrs:{"src":_vm.svgPath}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 text-center"},[_c('div',{staticClass:"text-content"},[_c('h4',[_vm._v(_vm._s(_vm.message))])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-190f43c7","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/blank_state.vue
// module id = null
// module chunks = 